import axios from "axios"

export const signUp = (userDetails) => axios.post("/api/v1/accounts", userDetails)

export const getUser = (id) => axios.get(`/api/v1/accounts/${id}`)

export const getUsers = (query) =>
  axios.get("/api/v1/accounts", {
    params: {
      query
    }
  })

export const customUserFields = () => axios.get("/api/v2/custom_user_fields")

export const updateCustomUserValues = (values) => axios.patch("/api/v2/account/custom_user_values", { values })

export const newCommunityMembers = () => axios.get("/api/v2/new_members")

export const updateAvatar = (fileUrl) =>
  axios.post("/api/v1/account/avatar", {
    file_url: fileUrl
  })

export const updateDisplayName = (displayName) => axios.post("/api/v2/account/display_name", { display_name: displayName })

export const resetPassword = (email) =>
  axios.post("/api/v1/passwords", {
    email
  })

export const changePassword = ({ token, password }) =>
  axios.post("/api/v1/passwords/reset_by_token", {
    token,
    new_password: password
  })

export const resendEmailConfirmation = () => axios.post("/api/v1/account/confirmations/resend")

export const changeEmail = (email) =>
  axios.post("/api/v2/account/email", {
    email
  })

export const agreeToDocument = (legalDocument) => axios.patch("/api/v2/account/legal_document_agreement", legalDocument)

export const likedPosts = (ids) =>
  axios.get("/api/v2/account/likes", {
    params: {
      likeable_type: "Post",
      likeable_ids: ids
    }
  })

export const likedComments = (ids) =>
  axios.get("/api/v2/account/likes", {
    params: {
      likeable_type: "Comment",
      likeable_ids: ids
    }
  })

export const likedFiles = (ids) =>
  axios.get("/api/v2/account/likes", {
    params: {
      likeable_type: "Asset",
      likeable_ids: ids
    }
  })

export const pollVotes = (ids) =>
  axios.get("/api/v2/account/poll_votes", {
    params: {
      question_ids: ids
    }
  })

export const scheduledPosts = () => axios.get("/api/v2/account/scheduled_posts")

export const marketingPreferences = () => axios.get("/api/v2/account/marketing_preferences")

export const updateMarketingPreferences = (preferences) =>
  axios.patch("/api/v2/account/marketing_preferences", {
    ...preferences
  })

export const publishKey = () => axios.get("/api/v2/pubnub_publish_key")

export const reportUser = (id, reason) => axios.post(`/api/v1/accounts/${id}/reports`, { reason })

export const shadowBanUser = (id) =>
  axios.post("/api/v2/account/shadowban", {
    member_id: id
  })

export const banUser = (id, unpublish) =>
  axios.post("/api/v2/account/ban", {
    member_id: id,
    unpublish_content: unpublish
  })

export const deleteAccount = ({ deleteAllContent } = {}) =>
  axios.delete("/api/v2/account", {
    data: {
      delete_content: deleteAllContent || false
    }
  })

export const profileFieldHeaderLogo = () => axios.get("/api/v3/profile_field_header_logo")

export const blockedUsers = () => axios.get("/api/v1/ignores")
